export default __webpack_public_path__ + "static/media/Venturer's Straps of Pierced Flesh.366f406b.jpg";